// helpers
import { makePieActionObjs } from "shared/imports/pieActionGenerators"
import { prependAppName } from "shared/imports/sharedHelperFunctions"

// async action types
const appName = "@@dashboards/"

const DashboardsActionTypes = {
    DASHBOARD_CLEAR_TEMPLATE_LIST: `${appName}DASHBOARD_CLEAR_TEMPLATE_LIST`,
    DESTROY_DASHBOARD_STORE: `${appName}DESTROY_DASHBOARD_STORE`,
    INITIALIZE_DASHBOARD: `${appName}INITIALIZE_DASHBOARD`,
    RECONCILE_DASHBOARD_LAYOUT: `${appName}RECONCILE_DASHBOARD_LAYOUT`,
    REMOVE_FROM_DASHBOARD_LAYOUT: `${appName}REMOVE_FROM_DASHBOARD_LAYOUT`,
    SELECT_DASHBOARD_FORM_TEMPLATE: `${appName}SELECT_DASHBOARD_FORM_TEMPLATE`,
    SET_DASHBOARD_VALUES: `${appName}SET_DASHBOARD_VALUES`,
    TOGGLE_CREATE_DASHBOARD_MODAL: `${appName}TOGGLE_CREATE_DASHBOARD_MODAL`,
    WIDGET_EDIT_FORM_SUBMIT_SEARCHIFY_FUNC: `${appName}WIDGET_EDIT_FORM_SUBMIT_SEARCHIFY_FUNC`,
    WIDGET_CREATE_FORM_CLEAR_TEMPLATE_LIST: `${appName}WIDGET_CREATE_FORM_CLEAR_TEMPLATE_LIST`,
}

export default DashboardsActionTypes

const fetchDashboardObjs = makePieActionObjs("fetch", "dashboard")

const loadDashboardObjs = makePieActionObjs("load", "dashboard")
export const loadDashboardActionDict = prependAppName(appName, loadDashboardObjs.pieDict)

const loadDashboardTemplateListObjs = makePieActionObjs("load", "dashboardTemplateList")
export const loadDashboardTemplateListActionDict = prependAppName(appName, loadDashboardTemplateListObjs.pieDict)

const postDashboardObjs = makePieActionObjs("post", "dashboard")
export const postDashboardActionDict = prependAppName(appName, postDashboardObjs.pieDict)

const patchDashboardObjs = makePieActionObjs("patch", "dashboard")
export const patchDashboardActionDict = prependAppName(appName, patchDashboardObjs.pieDict)

const loadWidgetObjs = makePieActionObjs("load", "widget")
export const loadWidgetActionDict = prependAppName(appName, loadWidgetObjs.pieDict)

const postWidgetObjs = makePieActionObjs("post", "widget")
export const postWidgetActionDict = prependAppName(appName, postWidgetObjs.pieDict)

const patchWidgetObjs = makePieActionObjs("patch", "widget")
export const patchWidgetActionDict = prependAppName(appName, patchWidgetObjs.pieDict)

const deleteWidgetObjs = makePieActionObjs("delete", "widget")
export const deleteWidgetActionDict = prependAppName(appName, deleteWidgetObjs.pieDict)

const loadWidgetTemplateListObjs = makePieActionObjs("load", "widgetTemlpateList")
export const loadWidgetTemplateListActionDict = prependAppName(appName, loadWidgetTemplateListObjs.pieDict)

const postWidgetTemplateSelectionObjs = makePieActionObjs("post", "widgetTemplateSelection")
export const postWidgetTemplateSelectionActionDict = prependAppName(appName, postWidgetTemplateSelectionObjs.pieDict)

const updateHomepageDashboardObjs = makePieActionObjs("patch", "dashboardHomepage")
export const updateHomepageDashboardActionDict = prependAppName(appName, updateHomepageDashboardObjs.pieDict)

const clearDashboardCacheObjs = makePieActionObjs("clear", "dashboardCache")
export const clearDashboardCacheActionDict = prependAppName(appName, clearDashboardCacheObjs.pieDict)

const clearDashboardWidgetCacheObjs = makePieActionObjs("clear", "dashboardWidgetCache")
export const clearDashboardWidgetCacheActionDict = prependAppName(appName, clearDashboardWidgetCacheObjs.pieDict)

export const actionTypes = prependAppName(
    appName,
    {
        ...deleteWidgetObjs.actionTypes,
        ...fetchDashboardObjs.actionTypes,
        ...loadDashboardObjs.actionTypes,
        ...loadWidgetObjs.actionTypes,
        ...patchDashboardObjs.actionTypes,
        ...patchWidgetObjs.actionTypes,
        ...postDashboardObjs.actionTypes,
        ...postWidgetObjs.actionTypes,
        ...loadWidgetTemplateListObjs.actionTypes,
        ...postWidgetTemplateSelectionObjs.actionTypes,
        ...updateHomepageDashboardObjs.actionTypes,
        ...clearDashboardCacheObjs,
        ...clearDashboardWidgetCacheObjs,
    }
)
